"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var isWithPlayerIdOptions_1 = __importDefault(require("./isWithPlayerIdOptions"));
function providePlayerIds(players, optionsSpec) {
    var _a, _b;
    var potentialIds = ((0, isWithPlayerIdOptions_1.default)(optionsSpec) ? optionsSpec.players.id.values
        : Array.from(Array(typeof players === 'number' ? players : players.length).keys()).map(function (id) { return id + 1; }));
    var mandatory = (_b = (_a = optionsSpec === null || optionsSpec === void 0 ? void 0 : optionsSpec.players) === null || _a === void 0 ? void 0 : _a.id) === null || _b === void 0 ? void 0 : _b.mandatory;
    var mandatoryIds = (mandatory ? Array.isArray(mandatory) ? __spreadArray([], mandatory, true) : [mandatory] : []);
    var result = typeof players === 'number' ? Array(players).fill(null) : __spreadArray([], players, true);
    while (mandatoryIds.some(function (id) { return !result.includes(id); })) {
        var mandatoryId = mandatoryIds.find(function (id) { return !result.includes(id); });
        var potentialIndexes = result.map(function (id, index) { return ({ id: id, index: index }); }).filter(function (r) { return !mandatoryIds.includes(r.id); }).map(function (r) { return r.index; });
        var index = potentialIndexes[Math.floor(Math.random() * potentialIndexes.length)];
        result[index] = mandatoryId;
    }
    var remainingIds = potentialIds.filter(function (id) { return !result.includes(id); });
    while (result.includes(null)) {
        var idIndex = Math.floor(Math.random() * remainingIds.length);
        var id = remainingIds.splice(idIndex, 1);
        result[result.indexOf(null)] = id[0];
    }
    return result;
}
exports.default = providePlayerIds;
//# sourceMappingURL=providePlayerIds.js.map